import axios from 'axios';
import store from '@/store';
import uuid from 'uuid/v4';

import formatResponse from '@/api/interceptors/format-response';
import catchError from '@/api/interceptors/format-error';

const $http = axios.create();

$http.interceptors.request.use(
  (config) => {
    if (store.getters.siteId) {
      config.headers['X-SITE-ID'] = store.getters.siteId;
    }
    config.headers['X-Request-Id'] = uuid();
    return config;
  },
  error => Promise.reject(error),
);

$http.interceptors.response.use(
  formatResponse,
  catchError,
);

export default $http;
